import styled, { css } from 'styled-components'

export const Tab = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  padding: 0;
  font-size: 15px;
  line-height: 100%;
  height: 40px;
  color: rgba(37, 37, 45, 0.5);
  border-radius: 4px;
  transition: all 150ms ease-in;
  position: relative;
  appearance: none;
  user-select: none;

  &:hover {
    color: #25252d;
  }

  &:active {
    color: #ac0ae8;
  }

  &:focus {
    outline: 0;
  }

  span:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 3px;
    bottom: 0;
    left: 0;
    background-color: #ac0ae8;
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 400ms cubic-bezier(0.86, 0, 0.07, 1);
  }

  ${({ active }) =>
    active &&
    css`
      color: #25252d;
      pointer-events: none;

      span:after {
        transform: scaleX(1);
        transform-origin: bottom left;
      }
    `};
`
